<template>
  <div>
    <!-- 触发按钮在父组件中使用 -->
    <el-dialog :title="dialogTitle" :visible.sync="batchDialogVisible" width="70%" @closed="handleDialogClosed"
      :destroy-on-close="true">
      <!-- 搜索区域 -->
      <div class="search-container">
        <el-select v-model="form.warehouse_id" placeholder="仓库" :disabled="!editWareHouse && wareHouse !== ''"
          style="width: 150px; margin-right: 10px;">
          <el-option v-for="(item, index) in wareHouseLists" :key="index" :label="item.name"
            :value="item.id"></el-option>
        </el-select>
        <el-input v-model="form.full_code" placeholder="货位" :disabled="fromLocation !== '' && !editCode" clearable
          style="width: 200px; margin-right: 10px;" />

        <el-input v-model="form.batch_number" placeholder="批次号" clearable style="width: 200px; margin-right: 10px;" />

        <el-button type="primary" icon="el-icon-search" @click="handleSearch">
          查询
        </el-button>
      </div>
      <div v-if="selectType == 2" class="coverBatch"></div>
      <!-- 数据表格 -->
      <el-table ref="batchTable" :data="listData" class="batch-tabel" row-key="id" :key="key" border
        style="width: 100%; margin-top: 15px;" @selection-change="handleSelectionChange" show-summary
        :summary-method="getSummary">
        <el-table-column type="selection" width="55" align="center"
          :selectable="selectType === 2 ? disableSelectAll : undefined" />
        <el-table-column prop="name" label="仓库" align="center" />
        <el-table-column prop="full_code" label="货位" align="center" />
        <el-table-column v-if="batchStatus" prop="batch_number" label="批次号" width="150" align="center">
          <template slot-scope="{ row }">
            {{ row.batch_number || '无批次' }}
          </template>
        </el-table-column>
        <el-table-column v-if="batchStatus" prop="start_date" label="生产日期" width="120" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.start_date && row.start_date != '0'">{{ row.start_date }}</span>
            <span v-else>/</span>
          </template>
        </el-table-column>
        <el-table-column label="有效期" align="center" v-if="batchStatus">
          <template slot-scope="scope">
            <span v-if="scope.row.realvalidity">
              {{ scope.row.realvalidity }}{{ validityunitTemp[scope.row.validityunit] }}
            </span>
            <span v-else>/</span>
          </template>
        </el-table-column>
        <el-table-column v-if="batchStatus" prop="end_date" label="到期日期" width="120" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.end_date && row.end_date != '0'">{{ row.end_date }}</span>
            <span v-else>/</span>
          </template>
        </el-table-column>
        <el-table-column prop="unit" label="基础单位" width="100" align="center" />
        <el-table-column prop="inventory" :label="selectType == 1 ? '可用库存' : '库存'" width="120" align="center" />

        <el-table-column v-if="selectType == 1" prop="numbers" label="数量" width="150" align="center">
          <template slot-scope="{ row }">
            <el-input-number v-model.number="row.numbers" :min="0" :max="row.inventory" controls-position="right"
              size="small" style="width: 120px;" />
          </template>
        </el-table-column>

      </el-table>

      <!-- 弹窗底部操作 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'BatchSelectionDialog',
  props: {
    selectType: {
      type: [Number, String],
      default: () => 1 // 1：多选  2：单选
    },
    editWareHouse: {
      type: Boolean,
      default: () => false // 是否可以编辑仓库下拉框
    },
    editCode: {
      type: Boolean,
      default: () => false // 是否可编辑货位输入框
    },
    isOut: {
      type: Boolean,
      default: () => false
    },
    isAll: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      key: '',
      batchDialogVisible: false,
      url: this.GLOBAL.domain + "Sell/index",
      dialogTitle: '',
      wareHouseLists: [],
      tableData: [],
      selectedRows: [],
      totalAvailableStock: 0,
      form: {
        act: 'get_batch_storage_inventory',
        full_code: '',
        batch_number: '',
        warehouse_id: '',
        product_id: '',
        storage_location_id: '',
        is_all: this.isAll ? true : undefined
      },
      listData: [],
      batchStatus: false,
      num: 0,
      validityunitTemp: {
        1: '日',
        2: '月',
        3: '年'
      },
      wareHouse: '',
      fromLocation: ''
    }
  },
  methods: {
    disableSelectAll() {
      return false; // 禁用所有行的可选状态（配合全选按钮）
    },
    // 打开弹窗
    /**
     * 
     * @param rowData 数据列表中选中的行数据
     * @param wareHouse 当前组件的仓库id，如果需要禁用仓库选择就传入仓库id
     * @param fromLocation 当前组件的货位id，如果需要禁用货位输入就传入货位id
     */
    openDialog(rowData, wareHouse, fromLocation) {
      this.wareHouse = wareHouse
      if (this.wareHouse) {
        this.form.warehouse_id = wareHouse
      } else {
        this.form.warehouse_id = rowData.warehouse
      }
      this.fromLocation = fromLocation
      if (this.fromLocation) {
        this.form.storage_location_id = fromLocation
      }
      this.num = +rowData.total_num || rowData.num
      this.batchStatus = localStorage.getItem('batchStatus') == 'true'
      this.dialogTitle = `${rowData.name} （编码：${rowData.number}）`
      this.rowData = rowData
      this.batchDialogVisible = true
      this.key = new Date().valueOf()
      this.form.product_id = rowData.productid
      this.loadTableData(rowData)
      this.getWarehouse()
    },

    // 加载表格数据
    async loadTableData(rowData) {
      const res = await this.$axios({
        url: this.url,
        method: 'get',
        params: this.form
      })
      if (res.Result === 0) {
        this.listData = res.Data.map(item => {
          return {
            ...item,
            numbers: 0
          }
        })
        if (this.fromLocation && res.Data.length) {
          this.form.full_code = res.Data[0].full_code
        }

        const listDataMap = new Map();
        this.listData.forEach(item => {
          listDataMap.set(item.id, item);
        });
        // 更换批次信息的时候回显        
        if (rowData && rowData.batch_info && rowData.batch_info.length > 0) {
          rowData.batch_info.forEach(item => {
            if (item.child && Array.isArray(item.child)) {
              item.child.forEach(cItem => {
                const targetId = cItem.batch_storage_inventory_id;
                const targetItem = listDataMap.get(targetId);
                if (targetItem) {
                  targetItem.numbers = cItem.numbers;
                  this.$nextTick(() => {
                    this.$refs.batchTable.toggleRowSelection(targetItem, true);
                  });
                }
              });
            }
          });
        } else if (rowData.batch_storage_inventory_id) {

          const targetId = rowData.batch_storage_inventory_id;
          const targetItem = listDataMap.get(targetId);
          if (targetItem) {
            this.$nextTick(() => {
              this.$refs.batchTable.toggleRowSelection(targetItem, true);
            });
          }
        }

        // if (this.selectType === 1) {
        //   // 首次进入自动分配逻辑
        //   // console.log("首次进入自动分配逻辑");
        //   let remaining = this.num;
        //   const rowsToSelect = [];

        //   for (const row of this.listData) {
        //     if (remaining <= 0) break;

        //     const available = Math.min(row.inventory, remaining);
        //     if (available > 0) {
        //       row.numbers = available;
        //       remaining -= available;
        //       rowsToSelect.push(row);
        //     }
        //   }

        //   this.$nextTick(() => {
        //     rowsToSelect.forEach(row => {
        //       this.$refs.batchTable.toggleRowSelection(row, true);
        //     });
        //   });

        //   if (remaining > 0) {
        //     this.$message.warning('当前库存不足，请手动调整分配数量');
        //   }
        // }
      }
    },
    /** 获取仓库 **/
    getWarehouse() {
      var resource = this.$resource(this.GLOBAL.domain + "Ware/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        } else {
          this.wareHouseLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

    // 计算合计
    getSummary(param) {
      const { columns, data } = param;
      const sums = [];
      const isSelectType1 = this.selectType === 1;

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        const prop = column.property;
        const label = column.label;

        // 处理库存列（包括可用库存和普通库存）
        // 无论选择模式如何，库存都统计所有行
        if (prop === 'inventory') {
          const total = data.reduce((sum, item) => {
            const value = Number(item.inventory) || 0;
            return sum + value;
          }, 0);
          sums[index] = total;
          return;
        }

        // 处理数量列（仅selectType=1时显示）
        if (isSelectType1 && prop === 'numbers') {
          // 多选模式：只统计选中行的数量
          let total = 0;
          this.selectedRows.forEach(row => {
            const value = Number(row.numbers) || 0;
            total += value;
          });
          sums[index] = total;
          return;
        }

        // 其他列不显示汇总
        sums[index] = '';
      });

      return sums;
    },

    // 查询处理
    handleSearch() {
      this.loadTableData()
    },

    // 多选处理
    handleSelectionChange(rows) {
      if (this.selectType == 2) {
        if (rows.length > 1) {
          const lastRow = rows[rows.length - 1];
          this.$nextTick(() => {
            this.$refs.batchTable.clearSelection();
            this.$refs.batchTable.toggleRowSelection(lastRow, true);
            this.selectedRows = [lastRow];
          });
        } else {
          this.selectedRows = rows;
        }
      } else {
        this.selectedRows = rows;
      }
    },
    // 弹窗关闭处理
    handleDialogClosed() {
      this.form = {
        act: 'get_batch_storage_inventory',
        full_code: '',
        batch_number: '',
        warehouse_id: '',
        product_id: '',
        is_all: this.isAll ? true : undefined
      },
        this.tableData = []
      this.selectedRows = []
    },

    // 确认提交
    handleConfirm() {
      if (this.selectType == 1) {
        // 多选
        let sum = 0;
        this.selectedRows.forEach(row => {
          if (typeof row.numbers === 'number' && row.numbers > 0) {
            sum += row.numbers;
          }
        });

        if (sum === 0) {
          return this.$message.error('数量不能为0');
        }
        if (sum != this.num) {
          return this.$message.error('数量总数必须等于' + this.num);
        }

        this.$emit('confirm', {
          id: this.rowData.id,
          selection: this.selectedRows
        });
      }
      if (this.selectType == 2) {
        // 单选
        if (this.selectedRows.length < 1) {
          return this.$message.error('请选择批次号再提交');
        }
        if (this.num > this.selectedRows[0].inventory && this.isOut) {
          return this.$message.error(`商品所需数量为${this.num}, 所选批次库存不满足！`);
        }
        this.$emit('confirm', {
          row: this.rowData,
          batchRow: this.selectedRows[0]
        });
      }

      this.batchDialogVisible = false;
    }
  }
}
</script>

<style scoped>
.search-container {
  display: flex;
  align-items: center;
  padding: 15px;
  background: #f8f8f9;
  border-radius: 4px;
}

.dialog-footer {
  margin-top: 20px;
  text-align: right;
}

.summary-row {
  background-color: #f5f7fa;
  font-weight: 600;
}

.summary-row td {
  padding: 12px 0;
}

::v-deep .el-table__append-wrapper {
  background-color: #f5f7fa;
}

.coverBatch {
  width: 40px;
  height: 40px;
  position: absolute;
  background: #ffffff;
  top: 180px;
  left: 28px;
  z-index: 9;
}
</style>


// WEBPACK FOOTER //
// src/components/home/ChangeBatch.vue